import { lazy, Suspense } from 'react'
import { RouterProvider } from 'react-router-dom'

import { PageLoader } from '@/components/ui/PageLoader'
import { useInitAuth } from '@/hooks/useInitAuth'
import { DEV_TOOLS_ENABLED } from '@/lib/devMode'
import router from '@/router'

// dev 상황 패널 — DEV_TOOLS_ENABLED(로컬 dev·배포 dev 호스트)에서만 lazy 로드.
// stg/prod 에서는 import() 자체가 호출되지 않아 청크가 다운로드되지 않는다.
const DevScenarioPanel = lazy(() =>
  import('@/components/DevScenarioPanel').then((module) => ({ default: module.DevScenarioPanel })),
)

export default function App() {
  const { authStatus } = useInitAuth()

  // 토큰 시도 중엔 백색 화면 + 스피너 — 비회원이어도 짧은 loading만 거치고 ready 됨 (timeout 5s 내)
  if (authStatus === 'loading') return <PageLoader />

  return (
    <>
      <RouterProvider router={router} />
      {DEV_TOOLS_ENABLED && (
        <Suspense fallback={null}>
          <DevScenarioPanel />
        </Suspense>
      )}
    </>
  )
}
